import { jsx as n } from "react/jsx-runtime";
import { useFormikContext as F } from "formik";
import { isFunction as l, get as T } from "lodash-es";
import k, { useState as K, useEffect as M, useCallback as f } from "react";
import { o as z, a as W } from "../../../events-CwIlKnwM.mjs";
import { s as A } from "../../../helpers-CNa1KUVl.mjs";
import { useWizardContext as U } from "../context/context.js";
import { Container as _, NavButton as b } from "./styled.js";
function H(x) {
  const { navigation: w = {}, validation: u, scrollOnSubmitError: h } = x, { fieldNames: d = [], schema: o } = u || {}, s = F(), t = U(), [S, v] = K(!1);
  delete s.validate, delete s.validationSchema;
  const { values: a, isSubmitting: C, isValidating: y, setFieldTouched: g, errors: N } = s;
  M(() => {
    (async () => {
      if (o)
        if (l(o)) {
          const i = await o(a, t.appStates).isValid(a, {
            context: a
          }) ?? !0;
          v(i);
        } else {
          const i = await o.isValid(a, {
            context: a
          }) ?? !0;
          v(i);
        }
    })();
  }, [o, t.appStates, a]);
  const r = f(
    (e) => {
      if (e.shouldValidate) {
        const i = l(d) ? d(a, t.appStates) : d;
        if (i.forEach((m) => {
          g(m, !0, !0);
        }), S)
          e.onClick(
            { dispatch: t.dispatch },
            s,
            t.appStates
          );
        else {
          if (e.onSubmitError) {
            const m = i.filter((B) => !!T(N, B));
            e.onSubmitError(s, m);
          }
          h && setTimeout(() => {
            A();
          }, 50);
        }
      } else
        e.onClick({ dispatch: t.dispatch }, s, t.appStates);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      u,
      a,
      t.appStates,
      t.dispatch,
      S,
      g,
      s,
      h
    ]
  ), E = f(
    (e) => z((i) => {
      i.preventDefault(), r(e);
    }),
    [r]
  ), D = f(
    (e) => W((i) => {
      i.preventDefault(), r(e);
    }),
    [r]
  ), { normal: c = [], edit: p = [], order: V = "ascending" } = w;
  return /* @__PURE__ */ n(_, { order: V, children: t.mode === "Edit" ? /* @__PURE__ */ n(k.Fragment, { children: (l(p) ? p(t.appStates) : p).map((e, i) => /* @__PURE__ */ n(
    b,
    {
      buttonType: e.type,
      onKeyDown: D(e),
      onMouseDown: E(e),
      disabled: y || C || !t.isNavigationEnabled || t.isUseButtonDisabled && e.isDisabled,
      children: e.content
    },
    i
  )) }) : /* @__PURE__ */ n(k.Fragment, { children: (l(c) ? c(t.appStates) : c).map((e, i) => /* @__PURE__ */ n(
    b,
    {
      "data-testid": `Wizard-NavigationButton-${i}`,
      type: e.isSubmit ? "submit" : "button",
      buttonType: e.type,
      onKeyDown: D(e),
      onMouseDown: E(e),
      disabled: y || C || !t.isNavigationEnabled || t.isUseButtonDisabled && e.isDisabled,
      children: e.content
    },
    i
  )) }) });
}
export {
  H as default
};
